module.exports = __webpack_public_path__ + "static/media/planet-image.39e74a91.png";